<div class="grid">
  <div class="col-12 xl:col-6">
    <div class="card flex p-6" *ngIf="userData">
      <div>
        <i class="pi pi-user p-5" style="font-size: 54px; border-radius: 50%; border: 3px solid #666666"></i>
      </div>
      <div class="ml-5 flex flex-column justify-content-around" *ngIf="userData.given_name">
        <p class="pb-0 mb-0 text-4xl">{{userData.name}}</p>
        <p class="pb-0 mb-0 text-lg">{{userData.username}}</p>
        <p class="pb-0 mb-0 text-lg" [class.font-italic]="!userData.email">{{userData.email ?? ('empty.email' | transloco)}}</p>
        <p class="pb-0 mb-0 text-lg" *ngIf="additionalUserData">
          {{additionalUserData.tenantName}}
          {{additionalUserData.organizationName ? ' (' + additionalUserData.organizationName + ')' : ''}}
        </p>
      </div>
      <div class="ml-5 flex flex-column justify-content-around" *ngIf="!userData.given_name">
        <p class="pb-0 mb-0 text-4xl">{{userData.username}}</p>
        <p class="pb-0 mb-0 text-lg" [class.font-italic]="!userData.email">{{userData.email ?? ('empty.email' | transloco)}}</p>
        <p class="pb-0 mb-0 text-lg" *ngIf="additionalUserData">
          {{additionalUserData.tenantName}}
          {{additionalUserData.organizationName ? ' (' + additionalUserData.organizationName + ')' : ''}}
        </p>
      </div>
    </div>
  </div>
  <div class="col-12 xl:col-6">
    <div class="card h-full flex flex-column">
      <div>
        <div class="flex justify-content-between">
          <p class="text-3xl mb-0">{{'forms.configuration' | transloco}}</p>
        </div>
        <hr>
      </div>
      <div class="flex flex-1 justify-content-evenly align-items-center my-3 xl:my-0">
        <div>
          <p class="bold mb-1">{{'options.language' | transloco}}:</p>
          <p-dropdown [(ngModel)]="selectedLanguage"
                      [options]="languages"
                      optionLabel="name"
                      filterBy="name"
                      styleClass="fixed-width-md dropdown-language">
            <ng-template pTemplate="selectedItem">
              <div class="flex align-items-center" *ngIf="selectedLanguage">
                <i [class]="'flag-icon flag-icon-' + selectedLanguage.code"></i>
                <p class="mb-0 ml-1 p-0">{{selectedLanguage.name}}</p>
              </div>
            </ng-template>
            <ng-template let-language pTemplate="item">
              <div class="flex align-items-center">
                <i [class]="'flag-icon flag-icon-' + language.code"></i>
                <p class="mb-0 ml-1 p-0">{{language.name}}</p>
              </div>
            </ng-template>
          </p-dropdown>
        </div>
        <div>
          <p class="bold mb-1">{{'options.timezone' | transloco}}:</p>
          <p-dropdown [(ngModel)]="selectedTimezone"
                      [options]="timezones"
                      [filter]="true"
                      (onChange)="onTimezoneChange($event)"
                      id="timezone"
                      optionValue="name"
                      optionLabel="name"
                      appendTo="body"
                      styleClass="fixed-width-md"></p-dropdown>
          <button pButton icon="pi pi-compass" class="p-button-icon-only" (click)="guessTimezone()"></button>
        </div>
        <div>
          <p class="mb-1">&nbsp;</p>
          <button pButton [label]="'common.save' | transloco" (click)="onSaveChanges()"></button>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12">
    <div class="card pb-2">
      <p class="text-3xl">{{'forms.myApps' | transloco}}</p>
      <hr>
      <div class="grid">
        <div *ngFor="let app of applications" class="col-12 lg:col-6 xl:col-4 p-2" style="height: 125px">
          <div class="p-0 h-full flex app-background" style="border-radius: 3px; border: 1px solid var(--surface-300);
                    background: linear-gradient(90deg, {{app.color}} 75px, rgba(255,254,255,1) 75px, rgba(255,254,255,1) 100%);">
            <div class="flex align-items-center justify-content-center" style="margin-left: 38px">
              <img [src]="'data:image/png;base64,' + app.icon" alt="" class="p-2"
                   style="width: 72px; height: 72px; border-radius: 50%; border:1px solid {{app.color}}; background-color: white">
            </div>
            <div class="flex flex-column justify-content-center ml-3">
              <p class="text-3xl mb-1">{{app.name | transloco}}</p>
              <p class="lowercase capitalize">{{('role.' + app.role) | transloco}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
